export default function FieldSelectorTemplate(data) {
    //language=HTML
    return `
        <link href="bootstrap4/css/bootstrap.min.css" rel="stylesheet">
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.0/css/all.min.css">
        <div class="demo-section wide">
            <nav id="breadcrumb"></nav>
        </div>

        <div id="grid"></div>
        <div class="k-d-flex">
            <div id="selectedFieldsGrid"></div>
            <div id="allSelectedFieldIdsGrid"></div>
        </div>
        <script>
            let query = getQueryParams(document.location.search);

            function getQueryParams(qs) {
                qs = qs.split('+').join(' ');
                let params = {},
                        tokens,
                        re = /[?&]?([^=]+)=([^&]*)/g;

                while (tokens = re.exec(qs)) {
                    params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
                }
                return params;
            }

            let fieldsSelector = new FieldsSelector(query.mainTable);
            fieldsSelector.drawWidgets();
        </script>

        <style>
            body {
                margin: 5px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
            }

            .btn:focus {
                box-shadow: none;
            }

            #grid {
                border: none;
            }

            #grid tr td:first-child,
            #selectedFieldsGrid tr td:nth-child(2),
            #allSelectedFieldIdsGrid tr td:first-child
            {
                overflow-wrap: anywhere;
            }

            .k-toolbar {
                justify-content: space-between;
                background-color: inherit;
                border: none;
                height: 45px;
            }

            .k-toolbar::before {
                display: none;
            }

        </style>`;
}